import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import Iframe from "react-iframe";

import { dataUserSession } from "../../../utilities/dataSession";
//SERVICE
import { pContractorContractInfo } from "../../../service/100/P115Service";

//PAGE
import P115List_1 from "./P115List_1";
import P115List_2 from "./P115List_2";
import P115List_3 from "./P115List_3";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { URL_MAP_DEFAULT } from '../../../service/Config';

export default function P115() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [requestSrh] = useState({
        contractNo: "", routeNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : '',
        token: dataUserSession() ? dataUserSession().token : '',
        ...history.location.state ? history.location.state : ''
    });

    const [isUrlMap, setIsUrlMap] = useState("");

    //Data
    const [dataTable, setDataTable] = useState([]);
    const [dataTable_1, setDataTable_1] = useState([]);
    const [dataTable_2, setDataTable_2] = useState([]);
    const [dataTable_3, setDataTable_3] = useState([]);

    useEffect(() => {
        if (dataUserSession()) {
            if (!history.location.state) {
                history.push("/109");
                // setRequestSrh({ contractNo: "ป.16-1/64", routeNo: 1, userId: dataUserSession().userId });
            }
        } else {
            history.push("/login");
        }
    }, []);
    useEffect(() => {

        onGetContractorContractInfo();
        setIsUrlMap(URL_MAP_DEFAULT() + "/Map115?userId=" + requestSrh.userId + "&token=" + requestSrh.token + "&contractNo=" + requestSrh.contractNo + "&routeNo=" + requestSrh.routeNo);
    }, [requestSrh]);

    const filterTable = (data, key) => {
        return data.filter((data) => {
            return data.recordType === key;
        });
    };

    const onGetContractorContractInfo = () => {
        setLoading(true);

        const req = {
            contractNo: requestSrh.contractNo,
            routeNo: requestSrh.routeNo,
            userId: requestSrh.userId,
        };
        pContractorContractInfo(req).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);

                    setDataTable_1(filterTable(temp, "1"));
                    setDataTable_2(filterTable(temp, "2"));
                    setDataTable_3(filterTable(temp, "3"));
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    // const showMapImage = (data) => {
    //     if (data.length > 0) {
    //         if (data[0].contractPhotoPath !== "") {
    //             return <img src={dataTable[0].contractPhotoPath} width="53%" />;
    //         } else {
    //             return <img src="assets/layout/images/noimage.jpg" width="53%" />;
    //         }
    //     } else {
    //         return <img src="assets/layout/images/noimage.jpg" width="53%" />;
    //     }
    // };

    return (
        <div>
            <Loading loading={loading} />
            <Toast ref={toast}></Toast>
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid" style={{ textAlign: "left" }}>
                            <div className="p-col-12">
                                <Button className="p-button-secondary p-button p-mr-2 p-mb-2" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => history.push("/109")} />
                            </div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-12">
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        {/* {googleMapsReady && (
                                            <div className="card">
                                                <GMap overlays={overlays} options={options} style={{ width: "100%", minHeight: "320px" }} onMapReady={onMapReady} onMapClick={onMapClick} onOverlayClick={onOverlayClick} onOverlayDragEnd={handleDragEnd} />
                                            </div>
                                        )} */}
                                        <div className="card" style={{ textAlign: "center" }}>
                                            {/* {showMapImage(dataTable)} */}
                                            <Iframe url={isUrlMap} width="100%" height="512px" id="myId" className="myClassname" display="initial" position="relative" />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6  " style={{ height: "50%" }}>
                                        <span>
                                            <h4>
                                                <b>รายละเอียดสัญญา</b>
                                            </h4>
                                        </span>
                                        <div className="card">
                                            <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                                <div className="p-col-12 p-md-12  " style={{ overflowY: "scroll", height: 280 }}>
                                                    {dataTable.map((item, index) => {
                                                        if (item.recordType == "1") {
                                                            return (
                                                                <span>
                                                                    <h4>{item.contractDetail}</h4>
                                                                </span>
                                                            );
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <span>
                                            <h4>
                                                <b>กรรมการ</b>
                                            </h4>
                                        </span>
                                        <P115List_1 dataTable={dataTable_1} />
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <span>
                                            <h4>
                                                <b>ผู้คุมงาน</b>
                                            </h4>
                                        </span>
                                        <P115List_2 dataTable={dataTable_2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-12">
                                <div className="card">
                                    <P115List_3 dataTable={dataTable_3} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
